export default function getClosestElements({ siblings, element }) {
  const { document } = window;

  const currentElementTop = element.offsetTop;
  const siblingTops = siblings.map(el => el.offsetTop);

  return siblingTops.reduce((closest, top) => {
    const distanceFromElement = Math.abs(currentElementTop - top);
    return distanceFromElement < closest ? distanceFromElement : closest;
  }, Infinity);
}
